import useMountFetch from './useMountFetch';

export default { useMountFetch };
